import { environment } from 'environments';

export const xcsrfEndPoint = `${environment.api.protocol}://${environment.api.hostname}${environment.api.apiPath}/token`;
export const sasEndPoint = environment.sas.url;
export const bpostHost = environment.bpost.host;
export const trackEndPoint = 'gebeurtenis';
